import React from "react";
import PrivacyPolicyLayer from "../components/PrivacyPolicyLayer";

const PrivacyPolicyPage = () => {
  return <PrivacyPolicyLayer />;
};

export default PrivacyPolicyPage;
